import * as WP from "../wp/index.js";
import {Result} from "../result/index.js";
export class Option {
  constructor(key, name, on) {
    this.key = key;
    this.name = name;
    this.on = on;
  }
}
const _Options = class {
  constructor(options) {
    this.options = options;
  }
  static fromWPJson(json) {
    const options = this.keys.map((k) => new Option(k[0], k[1], Boolean(json.getOr([k[0]], false))));
    return Result.ok(new _Options(options));
  }
};
export let Options = _Options;
Options.keys = [
  ["dealer", "\u30C7\u30A3\u30FC\u30E9\u30FC\u8ECA"],
  ["new", "\u65B0\u8ECA\u4E26\u884C"],
  ["parallel", "\u4E26\u884C\u8ECA"],
  ["at", "AT"],
  ["mtMode", "MT\u30E2\u30FC\u30C9\u4ED8\u304DAT"],
  ["mt", "MT"],
  ["carNav", "\u30AB\u30FC\u30CA\u30D3"],
  ["tv", "TV"],
  ["dvd", "DVD"],
  ["keyLess", "\u30AD\u30FC\u30EC\u30B9"],
  ["smartKey", "\u30B9\u30DE\u30FC\u30C8\u30AD\u30FC"],
  ["monitor", "\u5F8C\u5E2D\u30E2\u30CB\u30BF\u30FC"],
  ["etc", "ETC"],
  ["heat", "\u30B7\u30FC\u30C8\u30D2\u30FC\u30BF\u30FC"],
  ["sheetAc", "\u30B7\u30FC\u30C8\u30A8\u30A2\u30B3\u30F3"],
  ["leather", "\u672C\u9769\u30B7\u30FC\u30C8"],
  ["idling", "\u30A2\u30A4\u30C9\u30EA\u30F3\u30B0\u30B9\u30C8\u30C3\u30D7"],
  ["sensor", "\u969C\u5BB3\u7269\u30BB\u30F3\u30B5\u30FC"],
  ["cruise", "\u30AF\u30EB\u30FC\u30BA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB"],
  ["abs", "ABS"],
  ["airbug", "\u30A8\u30A2\u30D0\u30C3\u30B0"],
  ["antiSheft", "\u76D7\u96E3\u9632\u6B62\u88C5\u7F6E"],
  ["camera", "\u30AB\u30E1\u30E9"],
  ["foil", "\u30A2\u30EB\u30DF\u30DB\u30A4\u30FC\u30EB"],
  ["oneOwner", "\u30EF\u30F3\u30AA\u30FC\u30CA\u30FC"],
  ["noSmoking", "\u7981\u7159\u8ECA"],
  ["record", "\u5B9A\u671F\u70B9\u691C\u8A18\u9332\u3042\u308A"]
];
export class Car {
  constructor(id, slug, date, title, content, category, maker, image, price, capacity, modelYear, mileage, sold, options) {
    this.id = id;
    this.slug = slug;
    this.date = date;
    this.title = title;
    this.content = content;
    this.category = category;
    this.maker = maker;
    this.image = image;
    this.price = price;
    this.capacity = capacity;
    this.modelYear = modelYear;
    this.mileage = mileage;
    this.sold = sold;
    this.options = options;
  }
  static fromWPJson(json) {
    const id = json.getOr(["databaseId"], null);
    const slug = json.getOr(["slug"], null);
    const title = json.getOr(["title"], null);
    const content = json.getOr(["content"], null);
    const price = json.getOr(["acf", "carPrice"], null);
    const capacity = json.getOr(["acf", "capacity"], null);
    const modelYear = json.getOr(["acf", "modelYear"], null);
    const mileage = json.getOr(["acf", "mileage"], null);
    const sold = Boolean(json.getOr(["acf", "sold"], false));
    const categories = new WP.WPJson(json.getOr(["carCategories"], {}));
    const category = WP.Category.fromWPJson(categories).unwrapOrNull();
    const makers = new WP.WPJson(json.getOr(["makers"], {}));
    const maker = WP.Category.fromWPJson(makers).unwrapOrNull();
    const rawDate = json.getIf(["date"]);
    const date = rawDate.isOk() ? new Date(rawDate.unwrap()) : null;
    const rawImage = new WP.WPJson(json.getOr(["acf", "carImage"], {}));
    const image = WP.Image.fromWPJson(rawImage).unwrapOrNull();
    const rawOptions = new WP.WPJson(json.getOr(["acf"], {}));
    const options = Options.fromWPJson(rawOptions).unwrap();
    return new Car(id, slug, date, title, content, category, maker, image, price, capacity, modelYear, mileage, sold, options);
  }
}
//# sourceMappingURL=index.js.map
